import { FIELD_VALUES } from '@funnels/constants';
import { Owner, StoreApplicant } from '@funnels/types';

export const isExclusivelyOwnedByApplicantRole = (
  owners: Owner[],
  applicants: StoreApplicant[],
  targetApplicantRole: FIELD_VALUES.BORROWER | FIELD_VALUES.GUARANTOR
) =>
  owners.length > 0 &&
  owners.every((owner) => {
    const applicant = applicants.find((a) => a.id === owner.applicantId);
    return !applicant || applicant.applicantType === targetApplicantRole;
  });
